import cn from 'classnames';
import React, { forwardRef, type CSSProperties } from 'react';
import * as styles from './SwitchButtons.module.css';

type ButtonProps = {
  icon: React.ReactNode | string;
  title: React.ReactNode | string;
  description: React.ReactNode | string;
  isActive?: boolean;
  onClick: () => void;
};

function Button({ icon, isActive, title, description, onClick }: ButtonProps) {
  return (
    <button
      type="button"
      className={cn({
        [styles.button]: true,
        [styles.active]: isActive,
      })}
      onClick={onClick}
    >
      <div className={styles.icon}>{icon}</div>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
    </button>
  );
}

type InfoProps = {
  value: string | number;
} & Pick<ButtonProps, 'icon' | 'title' | 'description'>;

type SwitchButtonsProps<Type = any> = {
  value: Type;
  onChange: (value: Type) => void;
  info: [InfoProps] | [InfoProps, InfoProps];
  className?: string;
  style?: CSSProperties;
};

export const SwitchButtons = forwardRef<HTMLDivElement, SwitchButtonsProps>(function SwitchButtons(
  { value, onChange, info, className, style },
  ref
) {
  return (
    <div ref={ref} className={cn(styles.switchWrapper, className)} style={style}>
      {info.map((variant, idx) => {
        if (idx > 2) return null;
        return (
          <Button
            icon={variant.icon}
            onClick={() => {
              if (onChange !== null) {
                onChange(variant.value);
              }
            }}
            isActive={value === variant.value}
            title={variant.title}
            description={variant.description}
            key={variant.value}
          />
        );
      })}

      {info.length === 1 ? <div className={styles.switchSpacer} /> : null}
    </div>
  );
});
